import { useOfferHumanSupportCta } from "@circle-react/components/CircleAi/useOfferHumanSupportCta";
import { useOpenCircleAi } from "@circle-react/components/CircleAi/useOpenCircleAi";
import { useCreditBalance } from "@circle-react/hooks/useCreditBalance";

import { t } from "@/i18n-js/instance";

export interface SupportAskCircleAiCta {
  handleAskCircleAi: () => void;
  isAskCircleAiLoading: boolean;
}

export const useSupportAskCircleAiCta = () => {
  const {
    data: creditBalance,
    isError: isCreditBalanceError,
    isPending: isCreditBalanceLoading,
  } = useCreditBalance();
  const { openNewChatWithPrompt } = useOpenCircleAi();
  const { handleOfferHumanSupport, isOfferHumanSupportLoading } =
    useOfferHumanSupportCta();
  const isCreditBalanceUnavailable =
    creditBalance !== undefined && creditBalance.usage.available_credits === 0;

  const handleAskCircleAi = () => {
    if (isCreditBalanceLoading) return;

    if (isCreditBalanceError || isCreditBalanceUnavailable) {
      handleOfferHumanSupport();
      return;
    }

    openNewChatWithPrompt(
      t("settings.unified_inbox.human_support_ai_cta.draft_message"),
    );
  };

  return {
    handleAskCircleAi,
    isAskCircleAiLoading: isCreditBalanceLoading || isOfferHumanSupportLoading,
  };
};
